var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturpackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.35 253.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3891bc;}.cls-2{fill:#ffcf53;}.cls-3{fill:#1d1d1b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.61,134.43c-9.08,6.24-20.08,9.89-31.94,9.89-31.2,0-56.5-25.3-56.5-56.5h41.83l-54.8-54.79-54.78,54.79h36.43c0,48.5,39.32,87.82,87.83,87.82,20.52,0,39.39-7.03,54.34-18.82l-22.4-22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.74,41.22c9.08-6.24,20.09-9.89,31.94-9.89,31.2,0,56.5,25.29,56.5,56.5h-41.83l54.8,54.78,54.78-54.78h-36.43C287.5,39.32,248.18,0,199.68,0c-20.52,0-39.39,7.03-54.34,18.82l22.4,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,207.47H21.3c6.89,0,11.65,1.8,14.67,4.89,2.64,2.57,3.99,6.05,3.99,10.49v.13c0,6.89-3.67,11.45-9.27,13.83l10.75,15.7h-14.41l-9.07-13.64h-5.47v13.64H0v-45.04Zm20.72,21.62c4.25,0,6.69-2.06,6.69-5.34v-.13c0-3.54-2.57-5.34-6.76-5.34H12.48v10.81h8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.24,207.47h36.23v10.62h-23.87v6.82h21.62v9.84h-21.62v7.14h24.19v10.62H46.24v-45.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101,218.41h-13.51v-10.94h39.51v10.94h-13.51v34.1h-12.48v-34.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.25,232.76v-25.29h12.68v25.03c0,6.5,3.28,9.59,8.3,9.59s8.3-2.96,8.3-9.27v-25.35h12.68v24.97c0,14.54-8.3,20.91-21.11,20.91s-20.85-6.5-20.85-20.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.46,207.47h21.3c6.88,0,11.65,1.8,14.67,4.89,2.64,2.57,3.99,6.05,3.99,10.49v.13c0,6.89-3.67,11.45-9.27,13.83l10.75,15.7h-14.41l-9.07-13.64h-5.47v13.64h-12.48v-45.04Zm20.72,21.62c4.25,0,6.69-2.06,6.69-5.34v-.13c0-3.54-2.57-5.34-6.76-5.34h-8.17v10.81h8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.93,207.47h19.3c11.39,0,18.73,5.86,18.73,15.83v.13c0,10.62-8.17,16.21-19.37,16.21h-6.18v12.87h-12.48v-45.04Zm18.4,22.39c4.44,0,7.14-2.32,7.14-5.86v-.13c0-3.86-2.7-5.92-7.21-5.92h-5.86v11.9h5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.18,207.15h12.03l19.18,45.36h-13.38l-3.28-8.04h-17.37l-3.22,8.04h-13.13l19.18-45.36Zm10.94,27.6l-5.02-12.8-5.08,12.8h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.78,230.12v-.13c0-13.13,10.1-23.42,23.74-23.42,9.2,0,15.12,3.86,19.11,9.39l-9.39,7.27c-2.57-3.22-5.53-5.28-9.84-5.28-6.31,0-10.75,5.34-10.75,11.9v.13c0,6.76,4.44,12.03,10.75,12.03,4.7,0,7.46-2.19,10.17-5.47l9.39,6.69c-4.25,5.86-9.97,10.17-19.95,10.17-12.87,0-23.23-9.85-23.23-23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.98,207.47h12.48v18.27l15.51-18.27h14.8l-17.05,19.37,17.63,25.67h-14.99l-11.33-16.73-4.57,5.08v11.65h-12.48v-45.04Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturpackLogo);
export default __webpack_public_path__ + "static/media/returpack_logo.768fbeeebfd54385c6f12a3e3fd134d2.svg";
export { ForwardRef as ReactComponent };